import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "footer",

  setup() {
    let route = useRoute();
    console.log(route);
    const routerQuery = computed(() => {
      const query = {
        check: false
      };

      if (route.query.check === "true") {
        query.check = true;
      }

      return query;
    });

    const getIcp = () => {
      const host = window.location.host;

      switch (host) {
        case 'bodyparks.club':
          return '14';

        case 'body-park.cn':
          return '15';

        case 'bodypark.com.cn':
          return '16';

        case 'body-park.net':
          return '17';

        case 'bodypark.cn':
          return '18';

        default:
          return '18';
      }
    };

    return {
      routerQuery,
      getIcp
    };
  }

});